import { render, staticRenderFns } from "./configurationTemplate.vue?vue&type=template&id=823aa0ea&scoped=true"
import script from "./configurationTemplate.vue?vue&type=script&lang=js"
export * from "./configurationTemplate.vue?vue&type=script&lang=js"
import style0 from "./configurationTemplate.vue?vue&type=style&index=0&id=823aa0ea&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823aa0ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('823aa0ea')) {
      api.createRecord('823aa0ea', component.options)
    } else {
      api.reload('823aa0ea', component.options)
    }
    module.hot.accept("./configurationTemplate.vue?vue&type=template&id=823aa0ea&scoped=true", function () {
      api.rerender('823aa0ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/releaseManage/infoFrom/configurationTemplate.vue"
export default component.exports